const VITE_KEYS = [
  'VUE_APP_BASE_URL',
  'VUE_APP_KEYCLOAK_REALM',
  'VUE_APP_KEYCLOAK_AUTH_SERVER',
  'VUE_APP_KEYCLOAK_RESOURCE',
  'VUE_APP_KEYCLOAK_URL',
  'VUE_APP_KEYCLOAK_CLIENT_ID',
  'VUE_APP_GRAPHQL_HTTP',
  'VUE_APP_GRAPHQL_WS',
  'VUE_APP_S3_BUCKET_LEADSPARK_TULU_FILES_PATH',
] as const;

type EnvKey = (typeof VITE_KEYS)[number] | 'NODE_ENV';

function readGlobal(name: string): string {
  const config = (window as Window & { GLOBAL_CONFIG?: Record<string, string | undefined> }).GLOBAL_CONFIG;
  const fromWindow = config?.[name];
  if (typeof fromWindow === 'string' && fromWindow.length > 0) {
    return fromWindow;
  }
  return '';
}

function readVite(name: string): string {
  const value = import.meta.env[name as keyof ImportMetaEnv];
  return typeof value === 'string' ? value : '';
}

export function resolveParam(name: EnvKey): string {
  return readGlobal(name) || readVite(name);
}

export const environment = {
  get keycloakRealm() {
    return resolveParam('VUE_APP_KEYCLOAK_REALM');
  },
  get keycloakAuthServer() {
    return resolveParam('VUE_APP_KEYCLOAK_AUTH_SERVER');
  },
  get keycloakResource() {
    return resolveParam('VUE_APP_KEYCLOAK_RESOURCE');
  },
  get keycloakUrl() {
    return resolveParam('VUE_APP_KEYCLOAK_URL');
  },
  get keycloakClientId() {
    return resolveParam('VUE_APP_KEYCLOAK_CLIENT_ID');
  },
  get graphqlHttp() {
    return resolveParam('VUE_APP_GRAPHQL_HTTP') || 'http://localhost:4000/graphql';
  },
  get graphqlWs() {
    return resolveParam('VUE_APP_GRAPHQL_WS');
  },
  get environmentName() {
    return resolveParam('NODE_ENV') || import.meta.env.MODE;
  },
  get s3BucketLeadsparkTuluFilesPath() {
    return resolveParam('VUE_APP_S3_BUCKET_LEADSPARK_TULU_FILES_PATH');
  },
  get baseUrl() {
    return resolveParam('VUE_APP_BASE_URL') || window.location.origin;
  },
  get isProduction() {
    return this.environmentName === 'production';
  },
};
